export default __webpack_public_path__ + "static/media/envelope-fill.720aa125.svg";